<template>
  <div class="follow-official-accounts-modal" id="follow-official-accounts-modal">
    <el-dialog
      custom-class="el-dialog-official-accounts"
      title="关注公众号 推送订单状态"
      :visible.sync="qrcodeModalShow"
      @close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <hr />
      <div class="content-box">
        <div class="left-box">
          <p class="left-title">顾客下单、审核预约成功、出签发货立即通知</p>
          <img
            class="left-example-img"
            src="https://o.666visa.cn/static/ssqpeer/user/peer_cs_dialog_bg.png"
          />
        </div>

        <div class="middle-box"></div>

        <div class="right-box">
          <div class="right-item">
            <p class="right-title">微信扫一扫</p>
            <div class="img-box">
              <img
                src="../../assets/imgs/follow-modal/qrcode-modal.png"
                class="qrcode"
              />
            </div>
            <p class="right-bottom">（取消关注，将无法收到公众号推送）</p>
          </div>
          <div class="right-item">
            <p class="right-title">添加专属一对一签证顾问</p>
            <div class="img-box">
              <img v-if="peerCSData" :src="peerCSData.wx_qrcode" class="qrcode" />
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import {
  SAVE_MP_WATCH,
  SWITCH_MODAL_SHOW,
  SAVE_CLOSE_DATE,
  PAY_OK,
} from '@/store/modules/follow-official-accounts/follow-official-accounts-types';

import FormatDate from '@/services/format-date-service';
import Http from '@/libs/http';
import User from '@/libs/user';
import bus from '@/libs/bus';

export default {
  props: {},
  data() {
    return {
      itv: '',
    };
  },
  computed: {
    ...mapState('followOA', ['isLogin', 'mp_watch', 'payok']),
    ...mapState('user', ['peerCSData']),

    qrcodeModalShow: {
      // getter
      get() {
        console.log(this.$store.state.followOA.qrcodeModalShow);
        if (this.$store.state.followOA.qrcodeModalShow) {
          // 检测是否关注微信公众号
          this.itv = setInterval(() => {
            if (this.isLogin) {
              Http.post('/peer_account_query', {})
                .then((data) => {
                  if (data.mp_watch) {
                    this.SAVE_MP_WATCH({ mp_watch: data.mp_watch });
                    this.SWITCH_MODAL_SHOW({ show: false });
                    bus.$emit('close-follow-official-accounts-modal');
                    clearInterval(this.itv);
                  }
                })
                .catch((e) => {
                  if (e) console.log(e);
                });
            }
          }, 1500);
        } else {
          clearInterval(this.itv);
        }
        return this.$store.state.followOA.qrcodeModalShow;
      },
      // setter
      set(newVal) {
        if (!newVal) {
          this.SWITCH_MODAL_SHOW({ show: false });
          bus.$emit('close-follow-official-accounts-modal');
        }
      },
    },
  },
  created() {
    if (User.isLogin()) {
      this.getPeerCSData(true);
    }
  },
  methods: {
    ...mapMutations('followOA/', [
      SWITCH_MODAL_SHOW,
      SAVE_CLOSE_DATE,
      SAVE_MP_WATCH,
      PAY_OK,
    ]),
    ...mapActions('user', ['getPeerCSData']),

    modalClose() {
      if (!this.payok && !this.mp_watch) {
        this.SAVE_CLOSE_DATE({ date: FormatDate.formatDate(new Date()) });
      }
      if (this.payok) {
        this.PAY_OK({ payok: false });
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variable";
.follow-official-accounts-modal {
  .content-box {
    padding-top: 30px;
    display: flex;
    flex-direction: row;
    .left-box {
      text-align: center;
      flex-basis: 460px;
      margin-top: 20px;
      .left-title {
        font-size: 16px;
        line-height: 28px;
        color: #5f666e;
        padding-left: 20px;
      }
      .left-example-img {
        display: block;
        width: 374px;
        height: 304px;
        margin: 12px 33px 0 53px;
      }
    }
    .middle-box {
      width: 1px;
      height: 364px;
      border-left: 1px dashed #f0f0f0;
    }
    .right-box {
      margin: 34px 0 0 33px;
      text-align: center;
      display: flex;
      flex-direction: row;
      .right-item {
        margin-right: 20px;
        .right-title {
          font-size: 16px;
          line-height: 28px;
          color: #2F333D;
          font-weight: 600;
        }
        .img-box {
          position: relative;
          width: 200px;
          height: 200px;
          margin: 13px auto 8px;
          border: 1px solid #E9EEF2;
          .qrcode {
            width: 100%;
            height: 100%;
          }
        }
        .right-bottom {
          font-size: 14px;
          line-height: 28px;
          letter-spacing: 0px;
          color: #5F666E;
        }
      }
    }
  }
}
</style>

<style lang="less">
@import "../../assets/less/variable";
.follow-official-accounts-modal {
  .el-dialog {
    margin-bottom: 0;
    border-radius: 4px;
  }
  .el-dialog--small {
    width: 1000px;
    height: 520px;
    top: 20% !important;
    .el-dialog__header {
      text-align: center;
      padding-top: 24px;
      .el-dialog__title {
        font-size: 28px;
        color: #2F333D;
        line-height: 28px;
        font-weight: 600;
      }
      .el-dialog__headerbtn {
        position: absolute;
        top: 20px;
        right: 20px;
        .el-dialog__close {
          color: #777777;
          width: 15px;
          height: 15px;
        }
      }
    }
  }
}
.el-dialog-official-accounts .el-dialog__body {
  padding: 18px 0 0;
  hr {
    width: 46px;
    background-color: #4c97f7;
    border: 1px solid #4c97f7;
    margin: 0 auto;
    margin-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/follow-official-accounts-modal.vue